import { render, staticRenderFns } from "./ProductListingElement.vue?vue&type=template&id=22101e8d&"
import script from "./ProductListingElement.vue?vue&type=script&lang=js&"
export * from "./ProductListingElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports